import { AnyType } from "../../../../../common/constants";

/**
 * 上下限値内の数値が入力された場合に有効桁数に四捨五入します
 * @param param 入力値
 * @param digits 有効桁数
 * @param err 入力欄のエラー
 * @returns 入力欄に表示する文字列
 */
export function truncation(param: AnyType, digits: number, err: boolean): string {
  let val = param;
  if (err || val === undefined) {
    return val;
  }
  val =
    Math.round(Number(param) * Math.pow(10, digits)) / Math.pow(10, digits);
  return String(val);
}

